import { render } from "./TradeAvatarWithPlusYellow.vue?vue&type=template&id=ac2f3b76"
import script from "./TradeAvatarWithPlusYellow.vue?vue&type=script&lang=js"
export * from "./TradeAvatarWithPlusYellow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__